import React from 'react';

export default function UploadingIndicator({ size = 72 }) {
  const borderWidth = Math.max(4, Math.floor(size / 18));
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '16px' }}>
      <div
        aria-hidden
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `${borderWidth}px solid #E5E7EB`,
          borderTopColor: '#16a34a',
          animation: 'np-rotate 1s linear infinite'
        }}
      />
      <style>{`
        @keyframes np-rotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}


